import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "auth/authConfig";
import { env } from "configs/EnvironmentConfig";
import MyCustomToast from "pages/Toast/MyCustomToast";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import store from "store";
import App from "./App";
import { runSearchStickyJs } from "./helpers/utils";
import * as serviceWorker from "./serviceWorker";

const msalInstance = new PublicClientApplication(
  msalConfig(env.AZURE_TENANT_ID, env.AZURE_CLIENT_ID)
);

const app = (
  <ToastProvider components={{ Toast: MyCustomToast }} placement="top-right">
    <Provider store={store}>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </BrowserRouter>
    </Provider>
  </ToastProvider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.register("firebase-messaging-sw.js");
runSearchStickyJs();

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
